/* TFS v40 — Fiche produit : pastilles couleur en PHOTO + fin des sauts de page.

   Deux corrections :

   1. SAUT DE PAGE À LA SÉLECTION D'UNE TAILLE
      L'ancienne version appelait target.scrollIntoView() dès qu'une option
      changeait. Sur mobile, la condition qui devait l'éviter testait
      getComputedStyle(gallery).overflowX !== 'visible' — condition fausse
      dès que la galerie n'est pas un carrousel. Résultat : la page remontait
      vers la photo à chaque tap sur une taille. Ici, sur mobile, on ne
      déplace JAMAIS la page : au mieux on fait défiler la galerie
      horizontalement, et seulement si elle est réellement défilable.

   2. PASTILLES COULEUR EN PHOTO
      L'option couleur affichait un libellé texte dans une pastille colorée.
      On remplace par la vraie photo de la variante, récupérée depuis la
      galerie déjà présente dans le DOM (aucun téléchargement en plus :
      on réutilise l'URL de l'image, redimensionnée par le CDN Shopify).
      Le nom reste sous la photo, en petit, et dans le legend.
*/
(function () {
  'use strict';

  /* 990 et NON 767. C'est a 990 px que base.css bascule la galerie en bande
     horizontale (grid-auto-flow: column + overflow-x: auto + scroll-snap) et
     .product-main en colonne unique ; la vraie grille bureau a deux colonnes
     ne commence qu'a 991 px. Avec 767, la bande 768-990 px prenait la branche
     BUREAU - scrollIntoView(block: 'center') - sur une mise en page pourtant
     encore empilee : la galerie se recentrait dans la fenetre et poussait le
     bouton Precommander hors de l'ecran. C'est la seule bande pour laquelle
     personne n'avait ecrit de regle.
     Aligne sur le vrai point de bascule, ce script fait defiler la bande a
     l'horizontale partout ou elle EST une bande, et ne deplace la page que
     sur la vraie grille bureau. NE PAS remettre 767 sans changer d'abord le
     point de bascule de base.css. */
  var MOBILE = '(max-width: 990px)';

  function readVariants(root) {
    var node = root.querySelector('[data-product-json]');
    if (!node) return [];
    try { return (JSON.parse(node.textContent || '{}') || {}).variants || []; }
    catch (e) { return []; }
  }

  /* ─────────────────────────────────────────────────────────
     1. Galerie : mise en avant de la photo de la variante
     ───────────────────────────────────────────────────────── */
  function initGalleryFocus(root, variants) {
    if (root.dataset.variantFocusInit === '1') return;
    root.dataset.variantFocusInit = '1';
    if (!variants.length) return;

    function currentSelection() {
      return Array.prototype.map.call(
        root.querySelectorAll('[data-option-index]'),
        function (g) { var c = g.querySelector('input:checked'); return c ? c.value : undefined; }
      );
    }

    function findVariant() {
      var sel = currentSelection();
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var o = 0; o < variants[i].options.length; o++) {
          if (sel[o] !== undefined && variants[i].options[o] !== sel[o]) { ok = false; break; }
        }
        if (ok) return variants[i];
      }
      return null;
    }

    function focusMedia(mediaId, allowScroll) {
      var all = root.querySelectorAll('.product-media');
      for (var i = 0; i < all.length; i++) all[i].classList.remove('is-active-variant');
      if (!mediaId) return;

      var target = root.querySelector('[data-media-id="' + mediaId + '"]');
      if (!target) return;
      target.classList.add('is-active-variant');

      if (!allowScroll) return;

      var gallery = root.querySelector('.product-gallery');

      if (window.matchMedia(MOBILE).matches) {
        /* MOBILE : on ne bouge JAMAIS la page. Uniquement la galerie,
           et seulement si elle défile réellement à l'horizontale. */
        if (gallery && gallery.scrollWidth > gallery.clientWidth + 4) {
          var gr = gallery.getBoundingClientRect();
          var tr = target.getBoundingClientRect();
          try {
            gallery.scrollTo({ left: gallery.scrollLeft + tr.left - gr.left, behavior: 'smooth' });
          } catch (e) {
            gallery.scrollLeft = gallery.scrollLeft + tr.left - gr.left;
          }
        }
        return;
      }

      /* Desktop : la colonne photo est indépendante, le scroll ne dérange pas. */
      try { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    }

    function refresh(allowScroll) {
      var v = findVariant();
      if (v && v.featured_media_id) focusMedia(v.featured_media_id, allowScroll);
    }

    var inputs = root.querySelectorAll('[data-option-index] input');
    for (var i = 0; i < inputs.length; i++) {
      inputs[i].addEventListener('change', function () {
        setTimeout(function () { refresh(true); }, 60);
      });
    }

    /* État initial : on marque la photo, sans jamais déplacer la page. */
    refresh(false);
  }

  /* ─────────────────────────────────────────────────────────
     2. Pastilles couleur en photo
     ───────────────────────────────────────────────────────── */
  function resize(url, w) {
    if (!url) return url;
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=' + w);
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function isColourGroup(group) {
    var legend = group.querySelector('legend');
    var txt = (legend ? legend.textContent : '').toLowerCase();
    return /couleur|coloris|color|colour|teinte/.test(txt);
  }

  function initColourPhotos(root, variants) {
    if (root.dataset.colourPhotoInit === '1') return;
    root.dataset.colourPhotoInit = '1';
    if (!variants.length) return;

    var groups = root.querySelectorAll('[data-option-index]');

    for (var g = 0; g < groups.length; g++) {
      var group = groups[g];
      if (!isColourGroup(group)) continue;

      var idx = parseInt(group.getAttribute('data-option-index'), 10);
      if (isNaN(idx)) continue;

      var grid = group.querySelector('.option-grid');
      if (!grid) continue;

      var labels = grid.querySelectorAll('label');
      var applied = 0;

      for (var l = 0; l < labels.length; l++) {
        var label = labels[l];
        if (label.querySelector('.option-photo__img')) continue;

        var input = label.querySelector('input[type="radio"]');
        if (!input) continue;
        var value = input.value;

        /* première variante de cette couleur qui possède une photo */
        var mediaId = null;
        for (var v = 0; v < variants.length; v++) {
          if (variants[v].options[idx] === value && variants[v].featured_media_id) {
            mediaId = variants[v].featured_media_id; break;
          }
        }

        var source = mediaId ? root.querySelector('[data-media-id="' + mediaId + '"] img') : null;
        if (!source) source = root.querySelector('.product-gallery img');
        if (!source) continue;

        var url = source.getAttribute('src') || source.currentSrc || source.src;
        if (!url) continue;

        var pic = document.createElement('img');
        pic.className = 'option-photo__img';
        pic.src = resize(url, 200);
        pic.alt = value;
        pic.width = 68;
        pic.height = 85;
        pic.loading = 'lazy';
        pic.decoding = 'async';

        var span = label.querySelector('span');
        if (span) {
          span.className = 'option-photo__name';
          label.insertBefore(pic, span);
        } else {
          label.appendChild(pic);
        }

        label.classList.add('option-photo');
        label.setAttribute('title', value);
        applied++;
      }

      if (applied) grid.classList.add('option-grid--photo');
    }
  }

  /* ───────────────────────────────────────────────────────── */
  function initAll() {
    var roots = document.querySelectorAll('[data-product-root]');
    for (var i = 0; i < roots.length; i++) {
      var variants = readVariants(roots[i]);
      initColourPhotos(roots[i], variants);
      initGalleryFocus(roots[i], variants);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
